module.exports = __webpack_public_path__ + "img/huoqing.14ecbb0a.svg";